import { checkIfIconNameDeprecated } from './map';
import React, { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const FontAwesomeProIcon = forwardRef(
  ({ icon, type = 'solid', ...props }, ref) => {
    const types = {
      solid: 'fas',
      light: 'fal',
      brand: 'fab',
      regular: 'far',
    };

    if (!icon) {
      return (
        <p>
          You need to provide an <strong>icon name</strong>
        </p>
      );
    }

    return (
      <FontAwesomeIcon
        icon={[
          types[type],
          // check whether naming is deprecated
          checkIfIconNameDeprecated(icon),
        ]}
        ref={ref}
        {...props}
      />
    );
  },
);

FontAwesomeProIcon.propTypes = {
  icon: PropTypes.string,
  type: PropTypes.oneOf(['solid', 'light', 'brand', 'regular']),
};

FontAwesomeProIcon.displayName = 'FontAwesomeProIcon';

export default FontAwesomeProIcon;
